import { css } from '@emotion/core';
import { theme } from '@weave/theme';

export const container = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-image: url('assets/images/banner_sign_in.jpeg');
  background-size: cover;
`;
export const innerContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: ${theme.spacing(3, 1)};
  width: 350px;
  border-radius: ${theme.borderRadius.small};
  background-color: ${theme.colors.white};
  box-shadow: ${theme.shadows.floating};
  svg {
    margin-bottom: ${theme.spacing(1)};
  }
`;

export const divider = css`
  margin-bottom: ${theme.spacing(3)};
`;

export const updatedButtonStyles = css`
  width: 80% !important;
`;
